import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=438e4678&scoped=true&"
import script from "./Records.vue?vue&type=script&lang=js&"
export * from "./Records.vue?vue&type=script&lang=js&"
import style0 from "./Records.vue?vue&type=style&index=0&id=438e4678&prod&scoped=true&lang=css&"
import style1 from "./Records.vue?vue&type=style&index=1&id=438e4678&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438e4678",
  null
  
)

export default component.exports